import { PlanTypesEnum } from '@ctct/domain-layer';

import { SMS_INCLUDED_FREE_TOKEN, SMS_STARTING_PRICE_TOKEN, INBOX_PREVIEW_PRICE_TOKEN } from '../ContentStrategy';

export const contentInternational = {
  headers: {
    plans: [
      {
        id: PlanTypesEnum.Bronze,
        name: 'Lite',
        prePrice: 'Starting at',
        afterPrice: '/month*',
        suppressPriceDisplay: null,
      },
      {
        id: PlanTypesEnum.Silver,
        name: 'Standard',
        prePrice: 'Starting at',
        afterPrice: '/month*',
        suppressPriceDisplay: null,
      },
      {
        id: PlanTypesEnum.Gold,
        name: 'Premium',
        prePrice: 'Starting at',
        afterPrice: '/month*',
        suppressPriceDisplay: null,
      },
    ],
  },
  groups: [
    {
      id: 'platformManagement',
      name: 'Platform Management',
      features: [
        {
          id: 'platformManagement-users',
          feature: {
            name: 'Users',
            tooltipLabel: 'Number of users that work in the same account with different roles and permissions.',
          },
          parameters: [
            {
              id: '1',
              value: '1 user',
            },
            {
              id: '2',
              value: '3 users',
            },
            {
              id: '3',
              value: 'Unlimited',
            },
          ],
        },
        {
          id: 'platformManagement-monthlyEmailSends',
          feature: {
            name: 'Monthly email sends',
            tooltipLabel: 'Amount of emails included in your plan each month.',
            tooltipLinkText: 'Overage fees of $0.002 per email apply.',
            tooltipLinkUrl:
              'https://knowledgebase.constantcontact.com/email-digital-marketing/articles/KnowledgeBase/46046-Constant-Contacts-email-send-allowance-and-overage-fee?lang=en_US',
          },
          parameters: [
            {
              id: '1',
              value: '10x your number of contacts',
            },
            {
              id: '2',
              value: '12x your number of contacts',
            },
            {
              id: '3',
              value: 'Unlimited',
            },
          ],
        },
      ],
    },
    {
      id: 'email',
      name: 'Email',
      features: [
        {
          id: 'email-dragDropEmailTemplates',
          feature: {
            name: 'Drag & drop email templates',
            tooltipLabel: 'Choose from hundreds of professionally designed, customizable templates or create your own.',
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'email-brandKit',
          feature: {
            name: 'BrandKit',
            tooltipLabel:
              "Input your website url and we'll provide templates with your brand colors, logo, and images.",
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: false,
            },
          ],
        },
        {
          id: 'email-aiContentRecommendations',
          feature: {
            name: 'AI content recommendations',
            tooltipLabel: "Add a few keywords and we'll provide you with content options to choose from.",
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'email-pollsSurveys',
          feature: {
            name: 'Polls & surveys',
            tooltipLabel:
              'Create and share a poll or survey to better understand your customers. Just add it to your email and watch the responses flow in.',
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'email-scheduledEmailSends',
          feature: {
            name: 'Scheduled email sends',
            tooltipLabel: 'Send emails instantly or schedule for a future date and time, up to one year advance.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'email-subjectLineABTesting',
          feature: {
            name: 'Subject line A/B testing',
            tooltipLabel:
              "Compare two subject lines with a split test to ensure you're always sending the most effective subject line.",
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'email-subjectLineRecommendations',
          feature: {
            name: 'Subject line recommendations',
            tooltipLabel:
              'Enhance email engagement by selecting suggested subject lines and preheaders. Our system scans content, optimizing for nonprofit, retail, or real estate audiences. Currently for emails in English only.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: false,
            },
          ],
        },
        {
          id: 'email-subjectLinePersonalization',
          feature: {
            name: 'Subject line personalization',
            tooltipLabel:
              "Add contact details, like a first or last name, to your subject line. When your contacts read your subject line, they'll see details unique to them.",
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'email-dynamicContentInEmail',
          feature: {
            name: 'Dynamic content in email',
            tooltipLabel:
              "Personalize your emails by having parts of your content vary based on a contact's city, state, job title or any data point you collect.",
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: false,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'email-reachAndEngagementReporting',
          feature: {
            name: 'Reach and engagement reporting',
            tooltipLabel: "Easily know what's working best by seeing views, clicks, bounces, and unsubscribes.",
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'email-drilldownReporting',
          feature: {
            name: 'Drilldown reporting',
            tooltipLabel:
              'Learn more about how your campaigns are performing by drilling into what links are being clicked, who is engaging, and more.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'email-engagementHeatMap',
          feature: {
            name: 'Engagement heat map',
            tooltipLabel: "Know what's working by seeing where your most clicked links are located.",
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: false,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'email-newsletterArchive',
          feature: {
            name: 'Newsletter archive',
            tooltipLabel:
              'Host links for up to 100 previously sent emails on your website using this embeddable widget.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: false,
            },
          ],
        },
        {
          id: 'email-inboxPreview',
          feature: {
            name: 'Inbox preview',
            tooltipLabel:
              'See how your email renders in various email applications so you can spot errors and make adjustments prior to hitting the send button.',
          },
          parameters: [
            {
              id: '1',
              value: INBOX_PREVIEW_PRICE_TOKEN,
            },
            {
              id: '2',
              value: INBOX_PREVIEW_PRICE_TOKEN,
            },
            {
              id: '3',
              value: 'Free (unlimited tests)',
            },
          ],
        },
      ],
    },
    {
      id: 'automations',
      name: 'Automations',
      features: [
        {
          id: 'automations-automationsTemplates',
          feature: {
            name: 'Automations templates',
            tooltipLabel:
              'Library of pre-built templates for the most common automation needs. Includes Welcome Email, Birthday, Contact added to list, and more.',
          },
          parameters: [
            {
              id: '1',
              value: '1',
            },
            {
              id: '2',
              value: '3',
            },
            {
              id: '3',
              value: 'Unlimited',
            },
          ],
        },
        {
          id: 'automations-resendToNonOpeners',
          feature: {
            name: 'Resend to non-openers',
            tooltipLabel:
              "Increase open rates by choosing a timeframe to automatically resend an email to contacts who didn't open yet.",
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'automations-ecommerceAutomationTemplates',
          feature: {
            name: 'Ecommerce automation templates',
            tooltipLabel:
              'Library of pre-built templates triggered by actions taken on your eCommerce site, such as Abandoned Shopping Cart and more.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'automations-customAutomations',
          feature: {
            name: 'Custom automations',
            tooltipLabel: 'Build a custom automation from scratch to fit your unique needs.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
      ],
    },
    {
      id: 'socialMarketing',
      name: 'Social Marketing',
      features: [
        {
          id: 'socialMarketing-postOnFacebookInstagramLinkedIn',
          feature: {
            name: 'Post on Facebook, Instagram, LinkedIn',
            tooltipLabel:
              'Create and post on social media with our dashboard that automatically optimizes your copy and images for each platform.',
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'socialMarketing-socialReporting',
          feature: {
            name: 'Social reporting',
            tooltipLabel:
              'Get a sense of how your social posts are performing on Facebook or Instagram by viewing your overall reach and engagement activity for individual posts.',
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'socialMarketing-schedulePostsInAdvance',
          feature: {
            name: 'Schedule posts in advance',
            tooltipLabel: 'Create a post for multiple social platforms and schedule it to publish at a later time.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
      ],
    },
    {
      id: 'smsMarketing',
      name: 'SMS Marketing',
      features: [
        {
          id: 'smsMarketing-smsCampaigns',
          feature: {
            name: 'SMS campaigns',
            tooltipLabel: 'Reach customers directly, and immediately, on their mobile devices through text messages.',
          },
          parameters: [
            {
              id: '1',
              value: SMS_STARTING_PRICE_TOKEN,
            },
            {
              id: '2',
              value: SMS_STARTING_PRICE_TOKEN,
            },
            {
              id: '3',
              value: SMS_INCLUDED_FREE_TOKEN,
            },
          ],
        },
        {
          id: 'smsMarketing-textToJoin',
          feature: {
            name: 'Text-to-join',
            tooltipLabel:
              'Allow people to opt into your email and SMS list by sending a text message to a unique phone number assigned to your Constant Contact account.',
          },
          parameters: [
            {
              id: '1',
              value: 'Included with SMS marketing',
            },
            {
              id: '2',
              value: 'Included with SMS marketing',
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'smsMarketing-smsReporting',
          feature: {
            name: 'SMS reporting',
            tooltipLabel:
              'Check the number of sends, successful deliveries, bounces, unsubscribes, and the click rate for a sent SMS campaign.',
          },
          parameters: [
            {
              id: '1',
              value: 'Included with SMS marketing',
            },
            {
              id: '2',
              value: 'Included with SMS marketing',
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
      ],
      disclaimer: '*Standard SMS rates apply after your first 500 messages.',
      disclaimerLinkText: 'Standard SMS rates apply',
      disclaimerLinkUrl:
        'https://knowledgebase.constantcontact.com/email-digital-marketing/articles/KnowledgeBase/46517-Add-the-SMS-marketing-add-on-to-your-Constant-Contact-email-plan?lang=en_US',
    },
    {
      id: 'contactManagement',
      name: 'Contact Management',
      features: [
        {
          id: 'contactManagement-manageYourContacts',
          feature: {
            name: 'Manage your contacts',
            tooltipLabel:
              'Add and manage contacts in your account. You can manually add, import a list, or create an automatic way a contact gets added to your list.\nEvery email includes a SafeUnsubscribe® link assuring your customers that you have used a legitimate permission-based email provider.',
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'contactManagement-webSignUpForms',
          feature: {
            name: 'Web sign-up forms',
            tooltipLabel:
              'Turn visitors into leads with customizable forms and incentives to sign up like email promotions, a checklist, or a free consultation.',
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'contactManagement-contactSegmentation',
          feature: {
            name: 'Contact segmentation',
            tooltipLabel:
              'Get more engagement by creating customized segments with contact details, tags, and profiling information, then send personalized content to those who interacted with previous emails.',
          },
          parameters: [
            {
              id: '1',
              value: '1',
            },
            {
              id: '2',
              value: '10',
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'contactManagement-engagementSegmentation',
          feature: {
            name: 'Engagement segmentation',
            tooltipLabel: 'Identify subscribers most likely to engage with future campaigns.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: false,
            },
          ],
        },
        {
          id: 'contactManagement-ecommerceSegmentation',
          feature: {
            name: 'Ecommerce Segmentation',
            tooltipLabel: 'Send targeted content based on ecommerce activity.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: false,
            },
            {
              id: '3',
              value: false,
            },
          ],
        },
      ],
    },
    {
      id: 'ads',
      name: 'Ads',
      features: [
        {
          id: 'ads-socialMediaAdsManager',
          feature: {
            name: 'Social media ads manager',
            tooltipLabel:
              "Boost awareness and traffic for your business with our streamlined experience that displays ads in your target customer's Facebook and/or Instagram feeds.",
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'ads-facebookLookalikeAdTargeting',
          feature: {
            name: 'Facebook Lookalike Ad targeting',
            tooltipLabel:
              'Reach the right prospects by targeting people who look like your current customers or a specific segment.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: false,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'ads-googleAdsManager',
          feature: {
            name: 'Google Ads Manager',
            tooltipLabel:
              'Our streamlined experience automates ad setup and management so you get the most clicks for the lowest cost.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: false,
            },
            {
              id: '3',
              value: false,
            },
          ],
        },
        {
          id: 'ads-googleAdsCredit',
          feature: {
            name: '$500 Google Ads credit',
            tooltipLabel:
              'Spend $500 on Google Ads in your first 60 days and get an additional $500 in ad credit. New US accounts only.',
            tooltipLinkText: 'Terms and conditions apply',
            tooltipLinkUrl: 'https://www.google.com/ads/coupons/terms/',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: false,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
      ],
    },
    {
      id: 'events',
      name: 'Events',
      features: [
        {
          id: 'events-registrationForm',
          feature: {
            name: 'Registration form',
            tooltipLabel: 'Choose which information to collect from your contacts when they register for your event.',
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'events-payments',
          feature: {
            name: 'Payments',
            tooltipLabel:
              'Enable tickets, add promo codes, and set up payment methods as part of the registration and payment process.',
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: false,
            },
          ],
        },
        {
          id: 'events-sellProductsServices',
          feature: {
            name: 'Sell products & services',
            tooltipLabel:
              "If you're charging for event services or selling merch, you can collect payment during the registration process.",
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: false,
            },
          ],
        },
      ],
    },
    {
      id: 'additionalFeatures',
      name: 'Additional Features',
      features: [
        {
          id: 'additionalFeatures-marketingCampaignCalendar',
          feature: {
            name: 'Marketing campaign calendar',
            tooltipLabel: 'Stay organized and efficient with all your marketing activities mapped in one view.',
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'additionalFeatures-300Integrations',
          feature: {
            name: '300+ integrations',
            tooltipLabel:
              'Automatically sync contact and engagement data to save time, target your messaging, and deliver more successful campaigns.',
          },
          parameters: [
            {
              id: '1',
              value: true,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: true,
            },
          ],
        },
        {
          id: 'additionalFeatures-campaignBuilder',
          feature: {
            name: 'Campaign Builder',
            tooltipLabel: 'Tell us your goal and get a multi-channel campaign made for you in minutes.',
          },
          parameters: [
            {
              id: '1',
              value: false,
            },
            {
              id: '2',
              value: true,
            },
            {
              id: '3',
              value: false,
            },
          ],
        },
      ],
    },
  ],
  marketingData: {
    id: 'custom-plans',
    name: 'Plans',
    features: [
      {
        id: 'custom-plans',
        feature: {
          name: 'Plans',
          tooltipLabel: '',
        },
        parameters: [
          {
            id: '1',
            value: 'Lite',
          },
          {
            id: '2',
            value: 'Standard',
          },
          {
            id: '3',
            value: 'Premium',
          },
        ],
      },
      {
        id: 'custom-onboarding',
        feature: {
          name: 'Onboarding',
          tooltipLabel: "You'll speak 1:1 with our experts who will get you up and running in no time!",
        },
        parameters: [
          {
            id: '1',
            value: 'Live 1:1 onboarding with experts to help you get started fast',
          },
          {
            id: '2',
            value: 'Same as Lite',
          },
          {
            id: '3',
            value: 'Same as Lite',
          },
        ],
      },
      {
        id: 'custom-liveSupport',
        feature: {
          name: 'Live Support',
          tooltipLabel:
            'An award-winning customer support team is readily available to help customers across all plans. Premium customers receive priority support with experienced agents.',
        },
        parameters: [
          {
            id: '1',
            value: 'Live phone and chat with marketing experts',
          },
          {
            id: '2',
            value: 'Same as Lite',
          },
          {
            id: '3',
            value: 'Same as Lite',
          },
        ],
      },
      {
        id: 'custom-email',
        feature: {
          name: 'Email',
          tooltipLabel: 'Choose from hundreds of professionally designed customizable templates or create your own.',
        },
        parameters: [
          {
            id: '1',
            value: 'Easy to use drag-and-drop email editor, AI copy generator, and email templates',
          },
          {
            id: '2',
            value: 'Email scheduling and subject line testing',
          },
          {
            id: '3',
            value: 'Same as Standard',
          },
        ],
      },
      {
        id: 'custom-socialMediaMarketing',
        feature: {
          name: 'Social Media Marketing',
          tooltipLabel:
            'Start posting in minutes  — all in one place. Schedule content in a few clicks, reach new audiences with social posts, and turn followers into contacts.',
        },
        parameters: [
          {
            id: '1',
            value: 'Automatic posts on Facebook, Instagram, LinkedIn, and others to find new customers',
          },
          {
            id: '2',
            value: 'Schedule all social media posts in advance',
          },
          {
            id: '3',
            value: 'Share emails to LinkedIn & X/Twitter',
          },
        ],
      },
      {
        id: 'custom-reporting',
        feature: {
          name: 'Reporting',
          tooltipLabel: "See what's working and what's not with the ability to track your success in real time.",
        },
        parameters: [
          {
            id: '1',
            value: "Basic: See what worked and what didn't",
          },
          {
            id: '2',
            value: 'Advanced: See who opens and clicks on emails',
          },
          {
            id: '3',
            value: 'Same as Standard, plus heatmap for clicks',
          },
        ],
      },
      {
        id: 'custom-automation',
        feature: {
          name: 'Automation',
          tooltipLabel:
            'Set up easy automations to make sure your emails and texts go to the right person at the right time.',
        },
        parameters: [
          {
            id: '1',
            value: '1 automation template',
          },
          {
            id: '2',
            value: '3 automation templates, AI campaign builder, and automatic resend to non-openers',
          },
          {
            id: '3',
            value: 'Unlimited automations and blended Email & SMS workflows',
          },
        ],
      },
      {
        id: 'custom-contactManagement',
        feature: {
          name: 'Contact Management',
          tooltipLabel:
            'Add and manage contacts in your account. You can manually add, import a list, or create an automatic way a contact gets added to your list. Every email includes a SafeUnsubscribe® link assuring your customers that you have used a legitimate permission-based email provider.',
        },
        parameters: [
          {
            id: '1',
            value: 'Easy contact management, web signup forms, and 1 custom segment',
          },
          {
            id: '2',
            value: 'Same as Lite with 10 custom segments',
          },
          {
            id: '3',
            value: 'Unlimited segments',
          },
        ],
      },
      {
        id: 'custom-advertising',
        feature: {
          name: 'Advertising',
          tooltipLabel:
            'Boost awareness and traffic for your business with targeted display ads in Facebook and/or Instagram feeds.',
        },
        parameters: [
          {
            id: '1',
            value: false,
          },
          {
            id: '2',
            value: 'Powerful social media ads manager',
          },
          {
            id: '3',
            value: 'Create lookalike audiences on Facebook & Google Ads for targeting',
          },
        ],
      },
      {
        id: 'custom-events',
        feature: {
          name: 'Events',
          tooltipLabel:
            'Create, promote, and manage your event, all in one place. Enable tickets, add promo codes, and set up payment methods as part of the registration and payment process.',
        },
        parameters: [
          {
            id: '1',
            value: 'Host events, sell products, and take payments',
          },
          {
            id: '2',
            value: 'Host events, sell products, and take payments',
          },
          {
            id: '3',
            value: 'Create forms, emails, and SMS to support Events',
          },
        ],
      },
      {
        id: 'custom-integratedApps',
        feature: {
          name: 'Integrated Apps',
          tooltipLabel:
            'With over 300+ integrations, easily add your favorite apps to Constant Contact and sync data, simplify workflows, and amplify your marketing impact.',
        },
        parameters: [
          {
            id: '1',
            value:
              'Import your data using 300 integrations, including Google, Microsoft, Facebook, Canva, LinkedIn, Vimeo, Zapier, Shopify, Eventbrite and more!',
          },
          {
            id: '2',
            value:
              'Import your data using 300 integrations, including Google, Microsoft, Facebook, Canva, LinkedIn, Vimeo, Zapier, Shopify, Eventbrite and more!',
          },
          {
            id: '3',
            value:
              'Import your data using Salesforce, Wordpress, Gravity Forms, Zapier & Microsoft Dyanmics (coming soon)',
          },
        ],
      },
    ],
  },
};
